import React, { ReactElement } from 'react';
import { useState, useEffect } from 'react';
import { useParams, useNavigate, NavigateFunction } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';

import { RadioOrSelectOption } from '../../../../types/common.types';
import { Member } from '../../../../types/entity.types';
import { RootState } from '../../../../types/state/root.types';
import { MemberState } from '../../../../types/state/member.types';
import { TribeState } from '../../../../types/state/tribe.types';

import {
  requestViewApprovals,
  requestViewApprovalMembers,
  requestViewApprovalsForUser,
  requestUpdateAllPostStatus,
  requestUpdateAllCommentStatus
} from '../../../../api/approval/approval.actions';
import { requestViewTribeMembers } from '../../../../api/member/member.actions';

import TribeApprovals from '../../../../components/screens/programme/tribe/tribe-approvals/TribeApprovals';

const TribeApprovalsContainer = (): ReactElement => {
  const [membersToDisplay, setMembersToDisplay] = useState<Member[]>([]);
  const [filter, setFilter] = useState<RadioOrSelectOption>({
    label: 'All Awaiting Approval',
    value: 'all:pending approval'
  });

  const { approvalMembers, posts } = useSelector(({ tribe }: RootState): TribeState => tribe);
  const { members } = useSelector(({ member }: RootState): MemberState => member);

  const dispatch: Dispatch = useDispatch();

  const { status, programmeExternalReference } = useParams();

  const navigate: NavigateFunction = useNavigate();

  useEffect((): void => {
    // @ts-expect-error TODO: Fix after adding types to member actions
    dispatch(requestViewTribeMembers({ externalReference: programmeExternalReference }));
  }, [dispatch, programmeExternalReference, status]);

  useEffect((): void => {
    const [type, status] = filter.value.split(':');
    // @ts-expect-error TODO: Fix after adding types to approval actions
    dispatch(requestViewApprovals({ programmeExternalReference, type, status }));
    // @ts-expect-error TODO: Fix after adding types to approval actions
    dispatch(requestViewApprovalMembers({ programmeExternalReference }));
  }, [dispatch, programmeExternalReference, status, filter]);

  useEffect((): void => {
    if (approvalMembers && members) {
      const mappedMembers: Member[] = approvalMembers.map((approvalMember: Member): Member => {
        const { memberExternalReference } = approvalMember;
        const member: Member = members.find(
          (member: Member): boolean => member.memberExternalReference === memberExternalReference
        ) as Member;
        return {
          ...approvalMember,
          profilePicture: member.profilePicture
        };
      });

      setMembersToDisplay(mappedMembers);
    }
  }, [approvalMembers, members]);

  const viewApprovalsForUser = (systemUserExternalReference: string, onSuccess: () => void): void => {
    dispatch(
      // @ts-expect-error TODO: Fix after adding types to approval actions
      requestViewApprovalsForUser({
        programmeExternalReference,
        systemUserExternalReference,
        onSuccess
      })
    );
  };

  const updateAllPosts = (systemUserExternalReference: string, status: string, onSuccess: () => void): void => {
    dispatch(
      // @ts-expect-error TODO: Fix after adding types to approval actions
      requestUpdateAllPostStatus({
        programmeExternalReference,
        systemUserExternalReference,
        status,
        onSuccess: (): void => {
          onSuccess();
          const [type, status] = filter.value.split(':');
          // @ts-expect-error TODO: Fix after adding types to approval actions
          dispatch(requestViewApprovals({ programmeExternalReference, type, status }));
          // @ts-expect-error TODO: Fix after adding types to approval actions
          dispatch(requestViewApprovalMembers({ programmeExternalReference }));
        }
      })
    );
  };

  const updateAllComments = (systemUserExternalReference: string, status: string, onSuccess: () => void): void => {
    dispatch(
      // @ts-expect-error TODO: Fix after adding types to approval actions
      requestUpdateAllCommentStatus({
        programmeExternalReference,
        systemUserExternalReference,
        status,
        onSuccess: (): void => {
          onSuccess();
          const [type, status] = filter.value.split(':');
          // @ts-expect-error TODO: Fix after adding types to approval actions
          dispatch(requestViewApprovals({ programmeExternalReference, type, status }));
          // @ts-expect-error TODO: Fix after adding types to approval actions
          dispatch(requestViewApprovalMembers({ programmeExternalReference }));
        }
      })
    );
  };

  const navigateBack = (): void => {
    navigate(`/programmes/${status}/${programmeExternalReference}/tribe`);
  };

  return (
    <TribeApprovals
      status={status as string}
      posts={posts}
      members={membersToDisplay}
      filter={filter}
      setFilter={setFilter}
      viewApprovalsForUser={viewApprovalsForUser}
      updateAllPosts={updateAllPosts}
      updateAllComments={updateAllComments}
      navigateBack={navigateBack}
    />
  );
};

export default TribeApprovalsContainer;
